<template>
  <el-container>
    <el-header height="60px">
      <el-row>
        <!--        <el-col :span="8"><div class="header-grid-content">1</div></el-col>-->
        <el-col :xs="18" :sm="8" :md="8" :lg="8" :xl="8">
          <div class="logo_img">
            <el-image :src="logo" style="width: 45px;
                   height: 34px;"></el-image>
          </div>
          <div class="titile_logo"><a href="/">MxDraw云图帮助</a></div>
        </el-col>
        <el-col :xs="6" :sm="16" :md="16" :lg="16" :xl="16">
          <span class="hearder-tips logout" style="width: 50px" @click="logout">退出></span>
          <div  class="hidden-sm-and-down">
            <template  v-if="userInfo.usertype=='email'">
              <span class="hearder-tips" @click="drawer = true" >
                <i class="el-icon-user-solid"></i>
                {{userInfo.nickName}}
              </span>
            </template>
            <template v-else>
              <span class="hearder-tips">
                <i class="el-icon-user-solid"></i>
                {{userInfo.nickName}}
              </span>
            </template>
          <router-link to="mywork">
            <span class="hearder-tips">工单</span>
          </router-link>
          <router-link to="MxChm">
            <span class="hearder-tips">开发文档</span>
          </router-link>
          </div>
        </el-col>
        <el-drawer
          title="我是标题"
          :visible.sync="drawer"
          :with-header="false"
          size="15%"
          >
          <span>用户名：{{userInfo.nickName}}</span><br>
          <span>购买产品：{{userInfo.goods}}</span><br>
          <span>购买时间：{{userInfo.startTime}}</span><br>
          <span>到期时间：{{userInfo.endTime}}</span>
        </el-drawer>
      </el-row>
    </el-header>
    <el-container>
      <el-aside width="200px" class="hidden-sm-and-down">
        <el-row class="tac">
          <el-col :span="24">
            <el-menu
              default-active="2"
              router
              class="el-menu-vertical-demo"
              @open="handleOpen"
              @close="handleClose"
            >
              <el-menu-item index="/mywork" class="is-active">
                <i class="el-icon-location" @click="thsi.$router.push('mywork')"></i>
                <span slot="title">我的工单</span>
              </el-menu-item>
              <el-menu-item index="/workorder">
                <i class="el-icon-menu"></i>
                <span slot="title">创建工单</span>
              </el-menu-item>
                 <template v-if="userInfo.usertype=='email'">
                <a href="/downloadList"><el-menu-item index="3">
                  <i class="el-icon-document"></i>
                  <span slot="title">控件下载</span>
                </el-menu-item></a>
              </template>

              <!-- <el-menu-item index="3" disabled>
                <i class="el-icon-document"></i>
                <span slot="title">实时工单</span>
              </el-menu-item>
              <el-menu-item index="4" disabled>
                <i class="el-icon-setting"></i>
                <span slot="title">VIP技术支持</span>
              </el-menu-item>-->
            </el-menu>
          </el-col>
        </el-row>
      </el-aside>
      <el-container>
        <el-header class="hearder-2">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/mywork' }">我的工单</el-breadcrumb-item>
            <el-breadcrumb-item><a @click="go">工单详情</a></el-breadcrumb-item>
          </el-breadcrumb>
        </el-header>
        <el-main>
          <el-card shadow="always" style>
            <div class="tree_type" ref="tree_type" style="display: block">
              <div>
                <el-row>
                  <el-col :span="2" :offset="0">
                    <span>标题</span>
                  </el-col>
                  <el-col :span="22" :offset="0">
                    <div class="reply_index_other">
                    <el-input v-model="title" :disabled="true" clearable readonly="readonly"></el-input>
                    </div>
                  </el-col>
                </el-row>
              </div>

              <!-- <div style="margin: 30px 0;"></div>
              <div>
                <el-row>
                  <el-col :span="2" :offset="0">
                    <span>问题描述</span>
                  </el-col>
                  <el-col :span="22" :offset="0">
                    <div class="reply_index_account">
                    <el-input type="textarea" :rows="6" v-html="account" :disabled="true"></el-input>
                    </div>
                  </el-col>
                </el-row>
              </div> -->
              <div style="margin: 30px 0;"></div>

              <div>
                <el-row>
                  <el-col :span="2" :offset="0">
                    <span>问答</span>
                  </el-col>
                  <el-col :span="22" :offset="0">
                    <div class="reply_index" ref="replyIndex">

                      <dl style="clear:both;text-align:left;margin:6px 3px;padding:0;">
                        <template v-for="(item,i) in replyList">
                          <div :key="i">
                            
                            <dd style="float:left;margin:5px 0 0 4px;font-size:14px" >{{item.createTime}}&nbsp;
                            <strong>{{item.w_type==0?'提问':'回复'}}</strong> by 
                            <span style="font-size:14px">{{item.username}}</span>
                            </dd>
                            <dd style="clear:both;clear:both;background-color:#FAFAFA;border:1px solid #E3E3E3;margin:0 0 0 4px;padding:5px;">
                              <blockquote style="margin:10px 1px 0px 1px;overflow-x:auto;" v-html="item.reply">
                                <!-- 1.14日工作内容:<br>
                                1.修改登录系统的验证码频繁对比失败问题<br>
                                2.修改工单系统模块，数据接口修改意见数据库修改 -->
                            </blockquote>
                            
                            <blockquote style="margin:10px 1px 0px 1px;overflow-x:auto;" v-if="JSON.parse(item.file).length>0">
                              <template v-for="(item2,n) in JSON.parse(item.file)">
                                <div :key="n">
                                  <span>附件{{n+1}}:</span>
                                  <a :href="item2.url" :title="item2.name" target="_blank" style="color:#000;">点击查看/下载</a>
                                </div>                          
                              </template> 
                            </blockquote>
                            </dd>
                            <br>
                          </div>
                        
                          </template>
                          </dl>
                      <!-- <el-input type="textarea" :rows="8" v-html="reply" :disabled="true">



                      </el-input> -->
                    </div>

                    <!-- <div v-html="reply"></div> -->
                  </el-col>
                </el-row>
              </div>
              <div style="margin: 30px 0;"></div>
              <div>
                <el-row>
                  <el-col :span="2" :offset="0">
                    <span>继续提问</span>
                  </el-col>
                  <el-col :span="22" :offset="0">
                    <el-input type="textarea" :rows="8" placeholder="请输入您的问题" v-model="question"></el-input>
                  </el-col>
                </el-row>
              </div>
              <div style="margin: 30px 0;"></div>

              <div>
                <el-row>
                  
                  <el-col :span="2" :offset="2">
                    <!-- :before-upload="beforeUpload" -->

                    <el-upload
                      class="upload-demo"
                      action="/api/upload/"
                      
                      
                      :on-preview="handlePreview"
                      :on-remove="handleRemove"
                      :before-remove="beforeRemove"
                      multiple
                      :limit="3"
                      accept=".jpg,.png,.dwg,.dwf,.dxf,.txt" 
                      :on-exceed="handleExceed"
                      :file-list="fileList"
                      :on-success="uploadSuccess"
                    >
                      <el-button size="small" type="primary">添加附件</el-button>
                      <div slot="tip" class="el-upload__tip">注：单次上传文件不超过20M</div>
                    </el-upload>
                  </el-col>

                   <el-col :span="2" :offset="2">
                    <el-button type="primary" @click="submitQuestion" style="float:left">提交问题</el-button>
                  </el-col>
                </el-row>
              </div>
              <div style="margin: 40px 0;"></div>
              <div>
                <el-row>
                  <el-col>
                    <span class="div1">是否解决您的问题？</span>
                    <el-radio v-model="radio" label="1" border>已解决</el-radio>
                    <el-radio v-model="radio" label="0" border>未解决</el-radio>
                    <el-button type="primary" @click="submit">提交反馈</el-button>
                  </el-col>
        
                </el-row>
                <el-row>
                  
                  
                </el-row>
              </div>

              <!-- <div style="margin: 40px 0;"></div>
              <div>
                <el-row>
                  <el-col>
                    <el-button type="primary" @click="submit">提交反馈</el-button>
                  </el-col>
                </el-row>
              </div> -->

            </div>
          </el-card>
        </el-main>
      </el-container>
    </el-container>
  </el-container>
</template>

<script>
export default {
  name: "workinfo",
  data() {
    return {
      logo: require("../assets/img/logo2.png"),
      userInfo: {},
      radio: "",
      isSubmit: "",
      uuid: "",
      title: "",
      account: "",
      reply: "",
      replyTime: "",
      question:"",
      drawer: false,
      replyList:[],
        fileList: [
        // {
        //   name: "food.jpeg",
        //   url:
        //     "https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100",
        // },
        // {
        //   name: "food2.jpeg",
        //   url:
        //     "https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100",
        // },
      ],
    };
  },
  mounted() {
    this.get();
  },
  watch: {
    replyList(val) {
      this.$nextTick(()=>{
        let showReply = this.$refs.replyIndex;
        showReply.scrollTop = showReply.scrollHeight
      })
    }
  },

  methods: {
    get() {
      //  alert(1)
      var that = this;
      //发送get请求
      this.$api.get("/workInfo?uuid=" + that.$route.query.uuid).then(
        function (res) {
          if (res.data.userInfo.userId == 0) {
            that.$router.push("/login");
          } else if (res.data.code == "success") {
            that.userInfo = res.data.userInfo;
            that.title = res.data.workInfo.title;
            that.account = res.data.workInfo.account;
            that.reply = res.data.workInfo.reply;
            that.replyTime = res.data.workInfo.replyTime;
            that.replyList = res.data.replyList;
            that.uuid = res.data.workInfo.uuid;
            that.radio = "" + res.data.workInfo.solve;
            that.isSubmit = res.data.workInfo.solve;
            console.log(res);
          } else {
            that.$message({
              message: res.data.msg,
              type: "warning",
            });
          }
        },
        function () {
          that.$message.error("服务器异常，请稍后重试！");
        }
      );
    },
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
    go(){
       location.reload();
    },

    submit() {
      //提交工单反馈
      var that = this;
      var fk = that.radio;
      var uuid = that.uuid;

      if (!fk) {
        that.$message({
          message: "工单回复是否已解决您的问题？请选择“已解决”或“未解决”",
          type: "warning",
        });
        return;
      }
      if (that.isSubmit != null) {
        that.$message({
          message: "当前工单您已提交反馈，请勿重新提交",
          type: "warning",
        });
        return;
      }

      that.$api.post("/feedback", { uuid: uuid, fk: fk }).then(
        function (res) {
          if (res.data.code == "success") {
            that.$alert("感谢您的反馈，我们努力做到更好", "操作成功", {
              confirmButtonText: "确定",
              callback: (action) => {
                that.$router.push("/mywork");
                // this.$message({
                //   type: 'info',
                //   message: `action: ${ action }`
                // });
              },
            });
          } else if (res.data.code == "login") {
            that.$router.push("/login");
          } else {
            that.$message({
              message: res.data.msg,
              type: "warning",
            });
            return;
          }
        },
        function () {
          that.$message.error("服务器异常，请稍后重试！");
        }
      );
    },
    submitQuestion(){
      var that = this;
      var file = JSON.stringify(that.fileList);
      var question = that.question.replace(/\n/g,"<br/>");
      var uuid = that.$route.query.uuid;
      console.log(uuid)
      console.log(question)
      if (!question) {
        that.$message({
          message: "请先填写问题",
          type: "warning",
        });
        return;
      }
       that.$api.post("/submitQuestion", {
          uuid: uuid,
          question: question,
          file: file,
        })
        .then(
          function (res) {
            if (res.data.code == "success") {
              location.reload();
            } else if (res.data.code == "login") {
              that.$router.push("/login");
            } else {
              that.$message({
                message: res.data.msg,
                type: "warning",
              });
              return;
            }
          },
          function () {
            that.$message.error("服务器异常，请稍后重试！");
          }
        );

    },
      logout() {
      var that = this;
      this.$api.post(`/mxdraw_logout`).then(
        function (res) {
          that.$router.push("/login");
        },
        function () {
          that.$message.error("服务器异常，请稍后重试！");
        }
      );
    },
    mouseOver: function (e) {
      e.currentTarget.className = "grid-content bg-purple hover_border";
      //console.log("鼠标移入");

      //this.activeCss='hover_border'
    },
    mouseLeave: function (e) {
      // this.activeCss = '';
      e.currentTarget.className = "grid-content bg-purple";
      // console.log("鼠标移出");
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制上传 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
    beforeRemove(file, fileList) {
      // return this.$confirm(`确定移除 ${file.name}？`);
      var that = this;
      for (var i in that.fileList) {
          for (var k in that.fileList[i]) {
              if (that.fileList[i][k] == file.uid) {                                                 
              var index = that.fileList.indexOf(that.fileList[i]);
              if (index > -1) {
                 that.fileList.splice(index, 1);
              }	                       
              break;
            }
          }
        }
    },
    uploadSuccess(response, file, fileList){
        //console.log(response,file,fileList)
        var that = this;
        let files = {name:response.name,url:response.url};
        // let len = that.fileList.length;
        // that.fileList[len] = files;
        that.fileList.push(files);
      },
  },
};
</script>
<style>
.reply_index_other .el-input.is-disabled .el-input__inner {
  color: #000
}
</style>

<style scoped>
a {
    text-decoration:none;
    cursor:pointer !important;
  }

.upload-demo {
  text-align: left;
}

.hover_border {
  border: solid 1px #09f;
  color: #09f;
}

.grid-content {
  /*border-radius: 4px;*/
  /* display: flex; */
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100px;
  line-height: 100px;
  background-color: #f5f6fa;
  margin-bottom: 20px;
  width: 32%;
  margin-right: 10px;
}
.grid-content-img {
  width: 40px;
  height: 40px;
  line-height: 40px;
  margin-right: 10px;
}
.el-steps {
  text-align: left;
}
.hearder-tips {
  margin-left: 10px;
  float: right;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  cursor: pointer;
}
.el-breadcrumb {
  font-size: 17px;
  line-height: 60px;
}
.el-input-group {
  width: 15%;
  float: left;
  margin-bottom: 20px;
}
.el-header,
.el-footer {
  background-color: #ffffff;
  color: #333;
  text-align: center;
  line-height: 60px;
  border-bottom: solid 1px #e6e6e6;
}

.el-aside {
  background-color: #ffffff;
  color: #333;
  text-align: center;
  line-height: 800px;
  height: 800px;
}

.el-main {
  background-color: #eef0f4;
  color: #333;
  text-align: center;
  /*line-height: 160px;*/
}

body > .el-container {
  margin-bottom: 40px;
}

.el-container:nth-child(5) .el-aside,
.el-container:nth-child(6) .el-aside {
  line-height: 260px;
}

.el-container:nth-child(7) .el-aside {
  line-height: 320px;
}

.logo_img {
  width: 60px;
  height: 60px;
  line-height: 60px;
  float: left;
  display: flex;
  justify-content: center;
  align-items: center;
}
.logout {
  cursor: pointer;
}
.hearder-tips {
  color: #333;
}
.reply_index {
  min-height: 350px;
  max-height: 550px;
  text-align: left;
  border: 1px solid #dcdfe6;
  background-color: #f5f7fa;
  color: #000;
  /* cursor: not-allowed; */
  overflow: auto;
}
.reply_index_account{
  height: 150px;
  text-align: left;
  border: 1px solid #dcdfe6;
  background-color: #f5f7fa;
  color: #c0c4cc;
  /* cursor: not-allowed; */
  overflow: auto;
}
.reply_index_other{
  pointer-events:none;
}
input[disabled]{color:#000;opacity:1}
.el-row {
  display: flex;
  align-items: center;
}
  .titile_logo{
      line-height: 60px;
      float: left;
      cursor: pointer;
  }

  .titile_logo a{
    color: #333;
    text-decoration:none;
     font-weight: 600;
    font-size: 1.3rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/workInfo.vue